import React from 'react';
import type { DiffPart } from '../utils/transcripts';

/**
 * A saved transcript version as it stood, with the wording that save removed
 * kept visible and struck through, and the wording it added marked.
 */
export function TranscriptMarkup({
  parts
}: {
  parts: DiffPart[];
}) {
  return <div className="whitespace-pre-wrap border border-rule bg-paperDeep px-6 py-6 font-display text-xl leading-relaxed text-charcoal sm:px-9 sm:py-8 sm:text-2xl" data-id="element-417" data-mp="318hjiyo6v1w0">
      {parts.map((part, index) => part.kind === 'same' ? <span key={index} data-id="element-418" data-mp="28ku4s09ln5ha">{part.text}</span> : part.kind === 'added' ? <span key={index} className="bg-ink/[0.06] text-ink underline underline-offset-4" data-id="element-419" data-mp="2nhunxfdq5s45">
            {part.text}
          </span> : <span key={index} className="text-mute line-through" data-id="element-420" data-mp="2ijt2wowqniq1">
            {part.text}
          </span>)}
    </div>;
}